import React from 'react';
import { ENABLE_FULL_RESPONSIVE } from 'reactApp/appHelpers/configHelpers';
import { BREAKPOINT_MD, BREAKPOINT_SM } from 'reactApp/constants/breakpoints';
import { useWindowWidth } from 'reactApp/ui/VirtualList/VirtualList.hooks';

import styles from '../../DataListItemRow.css';
import { AllDocumentsItemProps } from '../../DataListItemRow.types';
import { Checkbox } from '../Checkbox';
import { Date } from '../Date';
import { Destination } from '../Destination';
import { Download } from '../Download';
import { Favorite } from '../Favorite';
import { ItemName } from '../ItemName';
import { Pic } from '../Pic';
import { Publish } from '../Publish';
import { Size } from '../Size';

const AlldocumentsItem: React.FC<AllDocumentsItemProps> = ({
    home,
    onCheckboxClick,
    isSelected,
    thumbUrl,
    isVirus,
    ext,
    name,
    favoritesAvailable,
    isInFavorites,
    onFavorites,
    mtime,
    size,
    onDownload,
    id,
    storage,
    onPublish,
    isPublic,
}) => {
    const path = home === '/' ? 'Облако' : home;
    const windowWidth = useWindowWidth();

    if (!ENABLE_FULL_RESPONSIVE) {
        <>
            <Checkbox onCheckboxClick={onCheckboxClick} isSelected={isSelected} />
            <Pic isFolder={false} thumbUrl={thumbUrl} isVirus={!!isVirus} ext={ext || ''} />
            <ItemName name={name} ext={ext || ''} id={id} />
            <Favorite isAvailable={!!favoritesAvailable} isActive={!!isInFavorites} onClick={onFavorites} />
            <Destination name={path} />
            <Date date={mtime} />
            <Size size={size} />
            <Download onClick={onDownload} ext={ext} size={size} id={id} storage={storage} />
            <Publish onClick={onPublish} isActive={isPublic} />
        </>;
    }

    return (
        <>
            {windowWidth > BREAKPOINT_SM ? (
                <ItemName name={name} ext={ext || ''} id={id} />
            ) : (
                <div className={styles.responsiveNameWrapper}>
                    <ItemName name={name} ext={ext || ''} id={id} />
                    <Destination name={path} noOverflow />
                    <span className={styles.responsiveDateWrapper}>
                        <Size size={size} />
                        {!!mtime && <>&nbsp;•&nbsp;</>}
                        <Date date={mtime} />
                    </span>
                </div>
            )}
            {windowWidth > BREAKPOINT_MD && (
                <Favorite isAvailable={!!favoritesAvailable} isActive={!!isInFavorites} onClick={onFavorites} />
            )}
            {windowWidth > BREAKPOINT_SM && (
                <>
                    <Destination name={path} />
                    {mtime && <Date date={mtime} />}
                    <Size size={size} />
                </>
            )}
            <div className={styles.actionsWrapper}>
                {windowWidth <= BREAKPOINT_MD && (
                    <Favorite isAvailable={!!favoritesAvailable} isActive={!!isInFavorites} onClick={onFavorites} />
                )}
                <Download onClick={onDownload} ext={ext} size={size} id={id} storage={storage} />
                <Publish onClick={onPublish} isActive={isPublic} />
            </div>
        </>
    );
};

export default AlldocumentsItem;
